import {
  Bell,
  DollarSign,
  HelpCircle,
  Home,
  LayoutGrid,
  LogOut,
  MessageSquare,
  Settings,
  ShoppingBag,
  Store,
  Marquee,
  Megaphone,
  HandCoins,
  FileText,
  Wallet,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../assets/css/admin/AdminSideBar/AdminSideBar.css";
import logo from "../../../assets/images/logo.png";
import { useContext } from "react";
import AppContext from "../../../context/AppContext";
import { MdHelpOutline } from "react-icons/md";


const AdminSideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { storeSelectedScreenOfAdminDashboardSidebar, logoutAdmin } =
    useContext(AppContext);

  const sidebarItems = [
    { id: "dashboard", path: "/admin-dashboard", icon: Home, label: "Dashboard" },
    {
      id: "categories",
      path: "/admin-categories",
      icon: LayoutGrid,
      label: "Category Management",
    },
    {
      id: "shops",
      path: "/admin-shops",
      icon: Store,
      label: "Shop Management",
    },

    {
      id: "topup-requests",
      path: "/admin-topup-requests",
      icon: Wallet,
      label: "Top-Up Requests"
    },
    //  {
    //   id: "payout-requests",
    //   path: "/admin-payout-requests",
    //   icon: HandCoins,
    //   label: "Payout Requests"
    // },

    {
      id: "blogs",
      path: "/admin-blogs",
      icon: FileText,
      label: "Blogs"
    },
    { id: "faqs", path: "/admin-faqs", icon: HelpCircle, label: "FAQs" },
    {
      id: "marquee",
      path: "/admin-marquee",
      icon: Megaphone,
      label: "Marquee"
    },


    { id: "supports", path: "/admin-supports", icon: MdHelpOutline, label: "Support Tickets" },
    {
      id: "notifications",
      path: "/admin-notifications",
      icon: Bell,
      label: "Notifications",
    },
    {
      id: "setting",
      path: "/admin-setting",
      icon: Settings,
      label: "Settings",
    },
  ];

  const handleItemClick = (item) => {
    storeSelectedScreenOfAdminDashboardSidebar(item.label);
    navigate(item.path);
  };

  const handleAdminLogout = () => {
    logoutAdmin();
    navigate("/admin-login");
  };

  return (
    <aside className="as-sidebar">
      {/* LOGO */}
      <div className="as-logo-wrapper">
        <img src={logo} alt="Logo" className="as-logo-icon" />
      </div>

      {/* MENU */}
      <nav className="as-nav">
        {sidebarItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          return (
            <div
              key={item.id}
              className={`as-nav-item ${isActive ? "as-active" : ""}`}
              onClick={() => handleItemClick(item)}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </div>
          );
        })}
      </nav>

      {/* LOGOUT */}
      <div className="as-bottom">
        <div className="as-logout-btn" onClick={handleAdminLogout}>
          <LogOut size={20} />
          <span>Logout</span>
        </div>
      </div>
    </aside>
  );
};

export default AdminSideBar;